<template>
    <div>
        <p class="text-certified h-hidden-xs">
            All products are certified, meet regulations and come with exeptionally high quality
        </p>
        <ul class="list list--inline h-hidden-xs">
            <li>
                <a href="#" title="#">
                    <img src="../../assets/img/srfooter1.png" alt="#"/>
                </a>
            </li>
            <li>
                <a href="#" title="#">
                    <img src="../../assets/img/srfooter2.png" alt="#"/>
                </a>
            </li>
            <li>
                <a href="#" title="#">
                    <img src="../../assets/img/srfooter3.png" alt="#"/>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {};
</script>
